import script from "./CreatorActivationHandoff.vue?vue&type=script&setup=true&lang=js"
export * from "./CreatorActivationHandoff.vue?vue&type=script&setup=true&lang=js"

import "./CreatorActivationHandoff.vue?vue&type=style&index=0&id=18207736&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18207736"]])

export default __exports__